/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown>, unitPrice: NonNullable<unknown> }} Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs */

const en_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} per person`)
};

const de_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} pro Person`)
};

const es_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} por persona`)
};

const fr_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} par personne`)
};

const nl_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} per persoon`)
};

const it_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} a persona`)
};

const pt_br2_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} por pessoa`)
};

const pl_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} za osobę`)
};

const hu_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} személyenként`)
};

const ro_admin_external_booking_edit_order_summary_extra_price_person = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} pe persoană`)
};

/**
* | output |
* | --- |
* | "{quantity} × {unitPrice} per person" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_extra_price_person = /** @type {((inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_Extra_Price_PersonInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_extra_price_person(inputs)
	return ro_admin_external_booking_edit_order_summary_extra_price_person(inputs)
});
export { admin_external_booking_edit_order_summary_extra_price_person as "admin.external_booking_edit.order_summary.extra_price_person" }